import { useEffect, useRef } from 'react'

/**
 * Sheet/palette/dialog are mounted globally and opened programmatically, so
 * Radix has no trigger to restore focus to on close — keyboard users get
 * dumped on <body>. Capture the focused element when the overlay opens and
 * hand it back via the returned onCloseAutoFocus handler.
 */
export function useRestoreFocus(open: boolean) {
  const previous = useRef<HTMLElement | null>(null)

  useEffect(() => {
    if (open) previous.current = document.activeElement as HTMLElement | null
  }, [open])

  return (event: Event) => {
    const target = previous.current
    if (target && typeof target.focus === 'function') {
      event.preventDefault()
      target.focus()
    }
  }
}
